import { render, staticRenderFns } from "./DoKoRestrictionPoverty.vue?vue&type=template&id=6ac65112&scoped=true&"
import script from "./DoKoRestrictionPoverty.vue?vue&type=script&lang=ts&"
export * from "./DoKoRestrictionPoverty.vue?vue&type=script&lang=ts&"
import style0 from "./DoKoRestrictionPoverty.vue?vue&type=style&index=0&id=6ac65112&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac65112",
  null
  
)

export default component.exports